import axios from 'axios'
import store from '@/store'
import camundaAPI from '@/services/camunda'

//  Base HTTP
const $baseHTTP = axios.create({
  baseURL: `${process.env.DICTIONARIES_PATH}`,
})

$baseHTTP.interceptors.response.use(cfg => cfg, (error) => {
  if (error !== 'Cancel' && error.constructor.name !== 'Cancel') {
    store.dispatch('tools/setSnackbar', `${error.response && error.response.status ? error.response.status : error}`
    + ` ${error.response && error.response.statusText ? error.response.statusText : ''}`
    + ` ${error.response && error.response.data && error.response.data.message ? error.response.data.message : ''}`)
  }
  return Promise.reject(error)
})

const CancelToken = axios.CancelToken

const api = {
  request(dictionary, payload) {
    if (dictionary === 'camunda/user') {
      return camundaAPI.user.query(payload)
    }
    return $baseHTTP.get(`/api/${dictionary}`, { params: payload })
  },

  postRequest(dictionary, payload) {
    if (dictionary === 'camunda/user') {
      return camundaAPI.user.query(payload)
    }
    return $baseHTTP.post(`/api/${dictionary}`, payload)
  },

  cancelableRequest(dictionary, payload) {
    const source = CancelToken.source()
    return { request: $baseHTTP.get(`/api/${dictionary}`, { params: payload, cancelToken: source.token }), source: source }
  },
}

export default api



// WEBPACK FOOTER //
// ./src/services/dictionaries.js